import React from 'react';
import {
  Box,
  Flex,
  ShowInLargeUp,
  ShowInMediumDown,
} from './../components/layout/Grid';
import BaseSkeleton from './../skeletons/BaseSkeleton';
import VideoCardSkeleton from './../skeletons/VideoCardSkeleton';
import Grid from '@components/CSSGrid';

const VideosGenresVideosSkeleton = ({ numberOfCards = 6 }) => (
  <React.Fragment>
    <Box as={ShowInMediumDown}>
      <Flex mb="20px" justifyContent="space-between" alignItems="center">
        <BaseSkeleton shape="square" height={20} width={35} />
        <BaseSkeleton shape="square" height={20} width={35} />
      </Flex>
    </Box>
    <Box as={ShowInLargeUp}>
      <Flex mb="20px" justifyContent="space-between" alignItems="center">
        <BaseSkeleton shape="square" height={20} width={10} />
        <BaseSkeleton shape="square" height={20} width={15} />
      </Flex>
    </Box>

    <Grid cardWidth={300}>
      {[...Array(numberOfCards).keys()].map((_, i) => (
        <VideoCardSkeleton key={i} />
      ))}
    </Grid>
  </React.Fragment>
);

export default VideosGenresVideosSkeleton;
